<div id="content">
  <ness-loader></ness-loader>
  <ness-banner></ness-banner>
  <main>
    <router-outlet></router-outlet>
  </main>
  <p-dialog [(visible)]="displayTimeoutDialog" header="NESS session timeout warning" [modal]="true" [baseZIndex]="10000" [resizable]="false" [attr.tabindex]="-1"  [breakpoints]="{'992px': '75vw', '576px': '90vw'}">
    <p>{{idleState}}</p>
    <p-footer>
      <button *ngIf="!timedOut" type="button" (click)="reset()" class="btn btn-active mx-2">Continue?</button>
    </p-footer>
  </p-dialog>
</div>
